const React = require('react');
const upperFirst = require('mn-utils/upperFirst');

const {
  DisplayDateMerchant,
  DisplayAmountMerchant,
  DisplayAmountFCMerchant
} = require('../../../../dumb/DisplayData');
const formatNum = require("../../../../../utils/formatNum");
const {ICONS_MAP, DEFAULT_ICON} = require("../constants/icons");

module.exports = (props) => {
  const data = props.data || {};

  const {
    created_at_date,
    released_at,
    fraction = 0,
    accum_amount = 0,
    accum_asset,
    target_amount = 0,
    target_asset,
    status = ''
  } = data;

  return (
    <div
      className={`w h layoutRow fhaS fvaC rlv lh fw7 f12 c2 tc lts0em
           ph20 (ph10|w1/5)>1 bgF6F6F6.even` + (props.index % 2 === 1 ? ' even' : '')}
      aria-rowindex={props.index}
    >
      <div
        aria-colindex="0"
      >
        <div className="layoutRow fvaC fhaS tl">
          {ICONS_MAP[status] || DEFAULT_ICON}
          <div className="pl17 fx1 wmin0">
            {status === 'released'
              ? (<span className="fw7">{upperFirst(status)}</span>)
              : (<span className="fw4">{upperFirst(status)}</span>)
            }
          </div>
        </div>
      </div>
      <div aria-colindex="1">
        <DisplayDateMerchant
          date={created_at_date}
        />
      </div>
      <div aria-colindex="2">
        <DisplayDateMerchant
          date={released_at}
        />
      </div>
      <div aria-colindex="3">
        {formatNum(fraction * 100, 4)}%
      </div>
      <div aria-colindex="4">
        {accum_amount && target_amount
          ? (
            <DisplayAmountFCMerchant
              fiat={{amount: accum_amount, symbol: accum_asset}}
              crypto={{amount: target_amount, symbol: target_asset}}
            />
          )
          : accum_amount
            ? (
              <DisplayAmountMerchant
                amount={accum_amount}
                symbol={accum_asset}
                type="fiat"
              />
            ) : (
              <DisplayAmountMerchant
                amount={target_amount}
                symbol={target_asset}
                type="crypto"
              />
            )
        }
      </div>
    </div>
  );
};
